import { FC } from "react";
import Image from "next/image";

const CustomersReviews: FC = () => {
  return (
    <div className="flex flex-col items-start  w-full py-10 md:py-16 text-white bg-landing-blue relative px-5 lg:px-20 xl:pt-24 h-fit justify-between">
      <h1>
        <span className="text-5xl hidden md:flex lg:hidden font-bold md:text-6xl whitespace-nowrap xl:text-7xl">
          You&apos;re in good
          <span className="text-landing-orange">&nbsp; company</span>
        </span>
      </h1>
      <div className="flex flex-col w-full md:flex-row">
        <div className="lg:w-1/2 h-auto">
          <h1 className="md:hidden block lg:block">
            <span className="text-5xl font-bold md:text-6xl whitespace-nowrap xl:text-7xl">
              You&apos;re in good
            </span>
            <span className="block mt-2 text-5xl font-bold md:text-6xl whitespace-nowrap text-landing-orange xl:text-7xl">
              company
            </span>
          </h1>
          <p className="font-serif text-xl max-w-xs xs:max-w-md md:max-w-none xl:text-2xl md:mt-4 xl:mt-7 md:leading-8 mt-7 md:w-[19.8rem] xl:w-[30.375rem]">
            Don&apos;t just take our word for it that we&apos;re awesome, read some reviews from
            satisfied customers.
          </p>
          {/* <div className="flex flex-row mt-8">
            <div className="text-base mr-2.5">Excellent</div>
            <div>
              <Image
                src="/cutomers-reviews/star.svg"
                alt="Customer Image"
                height={19}
                width={19}
                priority
              />
              <Image
                src="/cutomers-reviews/star.svg"
                alt="Customer Image"
                height={19}
                width={19}
                priority
              />
              <Image
                src="/cutomers-reviews/star.svg"
                alt="Customer Image"
                height={19}
                width={19}
                priority
              />
              <Image
                src="/cutomers-reviews/star.svg"
                alt="Customer Image"
                height={19}
                width={19}
                priority
              />
              <Image
                src="/cutomers-reviews/half-star.svg"
                alt="Customer Image"
                height={19}
                width={19}
                priority
              />
            </div>
            <div>
              <Image
                src="/cutomers-reviews/trustpilot.svg"
                alt="Customer Image"
                height={19}
                width={85}
                priority
              />
              <span>Trustpilot</span> 
            </div>
          </div> */}
        </div>

        <div className="relative h-48 md:h-64 lg:h-[480px] w-full mt-16 md:mt-0">
          <Image
            src="/icons/cutomers-reviews-head.svg"
            alt="Key Workers Image"
            objectFit="contain"
            priority
            layout="fill"
            className="right-0"
          />
        </div>
      </div>
    </div>
  );
};

export default CustomersReviews;
